class Text {
  constructor(container) {
    this.container = container
    this.english = container.querySelector('[data-text-english]')
    this.german = container.querySelector('[data-text-german]')
    this.en = container.querySelector('[data-lang-en]')
    this.de = container.querySelector('[data-lang-de]')
    this.init()
  }

  init() {
    this.container.scrollTop = 0
    this.oldScroll = 0
    this.setReverse(true)

    this.handleWindowResize()

    this.container.addEventListener('scroll', this.handleScroll)
    this.en.addEventListener('click', this.onLangClick)
    this.de.addEventListener('click', this.onLangClick)
    this.handleScroll()

    window.addEventListener('resize', this.handleWindowResize)
  }

  handleWindowResize = () => {
    if (window.innerWidth < 835) {
      this.container.style.overflow = 'hidden'
    } else {
      this.container.style.overflow = 'auto'
    }
  }

  onLangClick = e => {
    e.preventDefault()
    this.container.scroll({
      behavior: 'smooth',
      left: 0,
      top:
        this.container.scrollTop +
        (this.container.scrollHeight - this.container.clientHeight) / 2,
    })
  }

  handleScroll = () => {
    const root = document.documentElement || document.body

    const currScroll = this.container.scrollTop
    const windowHeight =
      this.container.scrollHeight - this.container.clientHeight

    const scrollDirection = currScroll >= this.oldScroll ? 'DOWN' : 'UP'

    root.style.setProperty('--rot', `${(currScroll / windowHeight) * 360}deg`)

    if (
      (scrollDirection === 'DOWN' && currScroll > (3 * windowHeight) / 4) ||
      (scrollDirection === 'UP' && currScroll < windowHeight / 4)
    ) {
      if (this.isReversed) {
        this.setReverse(true)
      }
    } else if (
      (scrollDirection === 'DOWN' && currScroll > windowHeight / 4) ||
      (scrollDirection === 'UP' && currScroll < (3 * windowHeight) / 4)
    ) {
      if (!this.isReversed) {
        this.setReverse()
      }
    }

    if (currScroll >= windowHeight && scrollDirection === 'DOWN') {
      this.container.scrollTop = 1
      this.setReverse(true)
    } else if (currScroll <= 0 && scrollDirection === 'UP') {
      this.container.scrollTop = windowHeight - 1
    }

    this.oldScroll = this.container.scrollTop
  }

  setReverse = reset => {
    if (reset) {
      this.english.classList.remove('is-inactive')
      this.german.classList.add('is-inactive')
      this.isReversed = false
    } else {
      this.english.classList.add('is-inactive')
      this.german.classList.remove('is-inactive')
      this.isReversed = true
    }
  }
}

const text = () => {
  const container = document.querySelector('[data-text]')

  if (container) {
    new Text(container)
  }
}
export default text
